/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleFactOwnershipTransitionInput
 */
export interface GoogleFactOwnershipTransitionInput {
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipTransitionInput
     */
    factFamily?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipTransitionInput
     */
    providerAccountKey?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipTransitionInput
     */
    nextSource?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipTransitionInput
     */
    nextIntegrationId?: string;
    /**
     * 
     * @type {Date}
     * @memberof GoogleFactOwnershipTransitionInput
     */
    effectiveFrom?: Date;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipTransitionInput
     */
    reason?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleFactOwnershipTransitionInput
     */
    shadowComparisonAccepted?: boolean;
}

/**
 * Check if a given object implements the GoogleFactOwnershipTransitionInput interface.
 */
export function instanceOfGoogleFactOwnershipTransitionInput(value: object): value is GoogleFactOwnershipTransitionInput {
    return true;
}

export function GoogleFactOwnershipTransitionInputFromJSON(json: any): GoogleFactOwnershipTransitionInput {
    return GoogleFactOwnershipTransitionInputFromJSONTyped(json, false);
}

export function GoogleFactOwnershipTransitionInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleFactOwnershipTransitionInput {
    if (json == null) {
        return json;
    }
    return {
        
        'factFamily': json['factFamily'] == null ? undefined : json['factFamily'],
        'providerAccountKey': json['providerAccountKey'] == null ? undefined : json['providerAccountKey'],
        'nextSource': json['nextSource'] == null ? undefined : json['nextSource'],
        'nextIntegrationId': json['nextIntegrationId'] == null ? undefined : json['nextIntegrationId'],
        'effectiveFrom': json['effectiveFrom'] == null ? undefined : (new Date(json['effectiveFrom'])),
        'reason': json['reason'] == null ? undefined : json['reason'],
        'shadowComparisonAccepted': json['shadowComparisonAccepted'] == null ? undefined : json['shadowComparisonAccepted'],
    };
}

export function GoogleFactOwnershipTransitionInputToJSON(json: any): GoogleFactOwnershipTransitionInput {
    return GoogleFactOwnershipTransitionInputToJSONTyped(json, false);
}

export function GoogleFactOwnershipTransitionInputToJSONTyped(value?: GoogleFactOwnershipTransitionInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'factFamily': value['factFamily'],
        'providerAccountKey': value['providerAccountKey'],
        'nextSource': value['nextSource'],
        'nextIntegrationId': value['nextIntegrationId'],
        'effectiveFrom': value['effectiveFrom'] == null ? value['effectiveFrom'] : value['effectiveFrom'].toISOString().substring(0,10),
        'reason': value['reason'],
        'shadowComparisonAccepted': value['shadowComparisonAccepted'],
    };
}

